<template>
    <ns-modal v-model="dialog" :fullscreen="fullscreen" :title="txc.change_password" @input="closeDialog">
        <server-error v-if="!!dialogError" :error="dialogError"/>
        <v-form ref="passwordForm" v-model="passwordFormValid" @submit.prevent data-testid="edit-password-modal">
            <ns-okta-password
                ref="currentPassword"
                testid="currentPassword"
                :translations="passwordTranslations('current')"
                :password="user.currentPassword"
                v-model="user.currentPassword"
                :criteriaOn="currentCriteria"
                :criteriaVisible="currentCriteria"
                :rulesOn="currentCriteria"
            />
            <ns-okta-password
                ref="newPassword"
                testid="newPassword"
                :hideCriteriaOnBlur=false
                :translations="passwordTranslations('new')"
                :password="user.newPassword"
                :externalStatusCode="externalStatusCode"
                v-model="user.newPassword"
                @valid="newPasswordValid = $event"
                @showPassword="showNewPassword"
            />
        </v-form>
        <template v-slot:actions>
            <v-layout column>
                <v-flex xs12>
                    <button
                        flat
                        block
                        class="primary-hit mb-2 fluid"
                        :disabled="!passwordFormValid"
                        @mousedown="updatePassword"
                        data-test-id="personalInfo-password-modal-save"
                    >{{ sharedStrings.generic.save }}
                    </button>
                </v-flex>
                <v-spacer/>
                <v-flex xs12>
                    <button
                        flat
                        block
                        class="secondary-hit fluid"
                        @mousedown="closeDialog"
                        data-test-id="personalInfo-password-modal-cancel"
                    >{{ sharedStrings.generic.cancel }}
                    </button>
                </v-flex>
            </v-layout>
        </template>
    </ns-modal>
</template>

<script>
import profileUtils from '@/repositories/profileUtils';
import {eventHub} from '../../eventHub';

import { ProfileService } from '@nuskin/ns-account';
import { NsModal, NsOktaPassword} from '@nuskin/design-components';
import ServerError from '@/components/ServerError';

import { mapGetters } from 'vuex';

export default {
    components: {
        NsOktaPassword,
        NsModal,
        ServerError
    },
    props: ['fullscreen','email'],
    data() {
        return {
            user: [],
            newPasswordValid: false,
            showPassword: false,
            currentCriteria: false,
            dialogError: null,
            dialog: true,
            externalStatusCode: '',
            form:{}
        }
    },
    computed: {
        ...mapGetters({
            txc: 'translationsPersonal',
            sharedStrings: 'sharedStrings'
        }),
        passwordFormValid() {
            return (
                this.user.currentPassword &&
                    this.user.newPassword &&
                    this.newPasswordValid
            );
        }
    },
    methods: {
        showNewPassword(val) {
            profileUtils.publishAnalytics(
                this.$analytics.category.personal,
                'password_dialog',
                `${val ? 'show' : 'hide'}_new_password`
            );
        },

        updatePassword() {
            let self = this;
            let passObj = {
                currentPassword: '',
                newPassword: this.user.newPassword
            };
            if (this.user.currentPassword !== undefined) {
                passObj.currentPassword = this.user.currentPassword;
            }

            ProfileService.updatePasswordProxy(passObj)
                .then(function (response) {
                    self.$set(self, 'passwordDialog', false);
                    self.passwordDialog = false;
                    self.user.newPassword = '';
                    self.user.currentPassword = '';
                    self.dialogError = null;
                    self.$refs.passwordForm.reset();
                    eventHub.$emit('resetPassword');
                    self.passwordDialog = false;
                    profileUtils.publishAnalytics(
                        self.$analytics.category.personal,
                        'password',
                        'updated',
                        {
                            email: self.email
                        }
                    );
                    self.closeDialog();
                })
                .catch(error => {
                    const resetPassFields = () => {
                        self.user.currentPassword = '';
                        self.user.newPassword = '';
                        self.$nextTick(() => {
                            self.$refs.currentPassword.$refs.password.$refs.input.focus();
                        });
                    }
                    if (error.response) {
                        // If error is specific for invalid current password
                        if (error.response.data.messages[0].technicalMessage == 'Old Password is not correct' ||
                            error.response.data.messages[0].technicalMessage == 'Invalid Credentials') {
                            self.$nextTick(() => {
                                self.$refs.currentPassword.$refs.password.$refs.input.focus();
                            });
                            self.user.currentPassword = '';
                        }
                        // Error for invalid new password
                        else if (error.response.data.messages[0].technicalMessage == 'Password cannot be your current password') {
                            self.$nextTick(() => {
                                self.$refs.newPassword.$refs.password.$refs.input.focus();
                            });
                            self.user.newPassword = '';
                        } else {
                            resetPassFields();
                        }
                    } else {
                        resetPassFields();
                    }
                    self.dialogError = error;
                    profileUtils.publishAnalytics(
                        self.$analytics.category.personal,
                        'password_update',
                        'error'
                    );
                });
        },

        passwordTranslations(passType) {
            let translations = {
                ...this.sharedStrings.password,
                newPassword: passType === 'current' ? this.sharedStrings.password.current_password : this.sharedStrings.password.newPassword,
                show: this.sharedStrings.forms.show,
                hide: this.sharedStrings.forms.hide
            }
            return translations
        },
        closeDialog(){
            this.$emit('closeDialog');
            this.dialog = false;
            this.dialogError = null;
        }

    },
    created() {
        profileUtils.publishAnalytics(this.$analytics.category.personal, 'password_dialog', 'opened');
    },
    destroyed() {
        profileUtils.publishAnalytics(this.$analytics.category.personal, 'password_dialog', 'closed');
    }
}
</script>
<style scoped>
</style>
